import React, { Component } from 'react';
import Autoload from '../../../../neoverv/Autoload';
import { isStarterTier, isPremiumTier } from '../../../../helpers/subscriptionFeatureAccess';
import { connect } from 'react-redux';
import { showNotification } from '@mantine/notifications';
import CopyIcon from '../../../../neoverv/components/SVGs/copyIcon';
import { Box, Group, Modal, Overlay, Stack, Radio, RadioGroup, TextInput, Popper, Popover, CheckboxGroup, Checkbox, Skeleton } from '@mantine/core';
import { InputLabel, MenuItem, Select, FormControl, TableContainer, TableHead, TableBody, TableCell, TableRow, Table, TableSortLabel, Tooltip, IconButton } from '@material-ui/core';
import TenantAccessDetails from './TenantAccessDetails';
import TenantAdministrateConsumption from './TenantAdministrateConsumption';
import TenantPortalPreview from './TenantPortalPreview';
import TenantAdministrationList from './TenantAdministrationList';
import { ColorButton, EmptyStateContainer, RecordOptions, SearchContainer, SwitchContainer } from '../../../../neoverv';
import TenantAdministrateDocuments from './TenantAdministrateDocuments';
import TenantAdministrateMessages from './TenantAdministrateMessages';
import PenIcon from '../../../../assets/images/module/general/PenIcon.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import Avatar from '../../../../assets/images/module/general/UserAccountBlue.svg';
import PdfIcon from '../../../../assets/images/module/general/PdfNewIcon.svg';
import XlsxIcon from '../../../../assets/images/module/general/XlsxIcon.svg';
import DownloadIcon from '../../../../neoverv/components/SVGs/downloadIcon';
import {
  changeCurrentProperty,
} from '../../../../redux/action/General/generalActions';
import dayjs from 'dayjs';
import moment from 'moment';
import { formatNumber } from '../../../../helpers/stringsManipulations';
import DatePicker from 'react-datepicker';
import { NumericFormat } from 'react-number-format';
import Icon from "../../../../components/Icon";
import UpdateTenantRentModal from '../../../../neoverv/components/Module/General/CustomModal/UpdateTenantRentModal';
import { load, unload } from "@finapi/web-form";
import accounting from 'accounting';
import UpdateAllTenantRentalReceivedRentModal from '../../../../neoverv/components/Module/General/CustomModal/UpdateAllTenantRentalReceivedRentModal';
import { setCurrentTenant, loadingTenantsData } from '../../../../redux/action/Tenant/TenantActions';
import * as XLSX from 'xlsx';
import classes from './TenantRentalIncomeTracking.module.css';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const MOBILE_SIZE = 992;
const TABLET_SIZE = 1420;

const paymentStatusOptions = [{value: 'paid', label: 'Vollständig'}, {value: 'unpaid', label: 'Offen'}, {value: 'partial_paid', label: 'Teilweise bezahlt'}];

export class TenantRentalIncomeTracking extends Component {
  openTenantSelectionModalRef = null;

  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= MOBILE_SIZE,
      isTablet: window.innerWidth <= TABLET_SIZE,
      selectedDateRange: 'current',
      dateRangeOptions: this.dateRangeForSpecificTenant,
      tableHeaderLabels: ['Mieter', 'Mieteinheit', 'Monat', 'Vertragsmiete', 'Zahlungseingang', 'Miete erhalten', 'Aktion'],
      openDateRangeModal: false,
      selectedDateRangeForModal: 'current',
      selectedTenant: [],
      tenantOptions: [
          // {
          //   value: 'all',
          //   label: 'Alle',
          //   name: '',
          //   tenantId: '',
          //   rentalUnit: '',
          //   rentalUnitId: ''
          // }
      ],
      openTenantSelectionModal: false,
      selectedTenantForModal: [],
      searchTenant: null,
      openUpdateTenantRentModal: false,
      selectedRentModalData: null,
      openWebFormModal: false,
      rentalPayments: [],
      offset: 0,
      stopOffsetChange: false,
      fetch: 100,
      fetchLoader: false,
      listLoader: false,
      orderBy: 'Monat',
      order: 'desc',
      allCheckBox: false,
      openUpdateAllTenantRentalReceivedRentModal: false,
      rentalUnits: [],
      exportRentalIncomePopoverOpen: false,
      exportRentalIncomeTablePopoverOpen: false,
      selectedTenantFromUrlParamsSet: false,
      openPaymentStatusModal: false,
      selectedPaymentStatusForModal: paymentStatusOptions.map((option)=> option.value) || [],
      selectedPaymentStatus: paymentStatusOptions.map((option)=> option.value) || [],
      paymentStatusOptions: paymentStatusOptions,
      tenantEditView: false,
      filteredRentalPayments: [],
      refreshAfterGetRentalPayments: false
    };

  }

  dateRangeForSpecificTenant=[
    {
      value: 'current',
      mobileLabel: 'Aktuelles Jahr',
      label: `Aktuelles Jahr (${dayjs().locale('de').startOf('year').format('MMMM YYYY')} - ${dayjs().locale('de').endOf('month').format('MMMM YYYY')})`, 
      date: {
        start: dayjs().locale('de').startOf('year'), 
        end: dayjs().locale('de').endOf('month')
      }
    },
    {
      value: 'last',
      mobileLabel: 'Letztes Jahr',
      label: `Letztes Jahr (${dayjs().locale('de').subtract(1, 'year').startOf('year').format('MMMM YYYY')} - ${dayjs().locale('de').subtract(1, 'year').endOf('year').format('MMMM YYYY')})`, 
      date: {
        start: dayjs().locale('de').subtract(1, 'year').startOf('year'), 
        end: dayjs().locale('de').subtract(1, 'year').endOf('year')
      }
    },
    {
      value: 'custom',
      mobileLabel: 'Benutzerdefiniert',
      label: `Benutzerdefiniert`, //(${dayjs().startOf('year').format('MMMM YYYY')} - ${dayjs().endOf('month').format('MMMM YYYY')})
      date: {
        start: new Date(moment().startOf('year')), 
        end: new Date(moment().endOf('month'))
      }
    },
  ]

  componentDidMount() {
    this.componentDidMountStuff();
  };

  // selectedTenant arrives as a JSON array of tenant ids in the query string. It is also
  // written by the AI assistant's navigation, so a malformed value has to degrade to "no
  // tenant preselected" rather than throw — an exception here happens during mount and takes
  // the whole screen down.
  parseSelectedTenantParam=(raw)=>{
    if(!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      return [];
    }
  }

  componentDidMountStuff=()=>{
    const {rentalUnits, selectedTenantId} = this.props;
    let url = new URL(window.location.href);
    window.addEventListener('resize', this.handleResize);
    this.setState({
      fetchLoader: true,
      selectedTenant: selectedTenantId ? [selectedTenantId] : this.parseSelectedTenantParam(url.searchParams.get("selectedTenant")),
      selectedTenantForModal: selectedTenantId ? [selectedTenantId] : this.parseSelectedTenantParam(url.searchParams.get("selectedTenant")),
      selectedDateRange: (url.searchParams.get("startDate") && url.searchParams.get("endDate")) ? this.returnSelectedDateRange(url.searchParams.get("startDate"), url.searchParams.get("endDate")) : 'current',
      selectedDateRangeForModal: (url.searchParams.get("startDate") && url.searchParams.get("endDate")) ? this.returnSelectedDateRange(url.searchParams.get("startDate"), url.searchParams.get("endDate")) : 'current',
      selectedTenantFromUrlParamsSet: (selectedTenantId || url.searchParams.get("selectedTenant")) ? true : false,
      selectedPaymentStatus: url.searchParams.get("paymentStatus") ? url.searchParams.get("paymentStatus").split(',') : paymentStatusOptions.map((option)=> option.value),
      selectedPaymentStatusForModal: url.searchParams.get("paymentStatus") ? url.searchParams.get("paymentStatus").split(',') : paymentStatusOptions.map((option)=> option.value),
      tenantEditView: window.location.href.includes('user/tenant/rentIncomeTracking') ? true : false,
      tableHeaderLabels: window.location.href.includes('user/tenant/rentIncomeTracking') ? ['Monat', 'Vertragsmiete', 'Zahlungseingang', 'Miete erhalten', 'Aktion'] : this.state.tableHeaderLabels
    }, ()=> this.bind_rental_unit_list_data());
  }

  componentDidUpdate(prevProps, prevState) {
    const {rentalPayments, selectedPaymentStatus, selectedTenant, selectedDateRange, refreshAfterGetRentalPayments} = this.state;
    console.log('componentDidUpdate: ', (JSON.stringify(prevState.rentalPayments) !== JSON.stringify(rentalPayments)));
    if(refreshAfterGetRentalPayments || (rentalPayments?.length > 0 && ((JSON.stringify(prevState.selectedTenant) !== JSON.stringify(selectedTenant)) || (JSON.stringify(prevState.selectedPaymentStatus) !== JSON.stringify(selectedPaymentStatus)) || (JSON.stringify(prevState.rentalPayments) !== JSON.stringify(rentalPayments)) || (prevState.selectedDateRange !== selectedDateRange)))){
      const filteredRentalPayments = rentalPayments.filter((rentalPayment)=> selectedTenant.find((tenantId)=> tenantId === rentalPayment.tenantId) !== undefined)
      .filter((rentalPayment)=> selectedPaymentStatus?.length === paymentStatusOptions?.length ? rentalPayment : selectedPaymentStatus.find((value)=> this.checkPaymentStatus(rentalPayment.expectedAdvancePayment, rentalPayment.expectedNetRent, rentalPayment.receivedAdvancePayment, rentalPayment.receivedNetRent) === value) !== undefined);
      
      let allCheckedRentalPayments = 0;
      filteredRentalPayments.map((rentalPayment)=> {
        if((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) == (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment)){
          allCheckedRentalPayments = allCheckedRentalPayments + 1;
        }
      });

      this.setState({ filteredRentalPayments, allCheckBox: filteredRentalPayments?.length === allCheckedRentalPayments, refreshAfterGetRentalPayments: false });
    }
  }

  returnSelectedDateRange=(startDate, endDate)=>{
    let {dateRangeOptions} = this.state;
    const parsedStartDate = dayjs(startDate);
    const parsedEndDate = dayjs(endDate);

    for (const range of this.dateRangeForSpecificTenant) {
      const { start, end } = range.date;

      if (
        start &&
        end &&
        parsedStartDate.isSame(dayjs(start), 'day') &&
        parsedEndDate.isSame(dayjs(end), 'day')
      ) {
        //In case of current or last
        return range.value;
      }
    }

    //In case of custom
    dateRangeOptions[2].date.start = new Date(startDate);
    dateRangeOptions[2].date.end = new Date(endDate);
    this.setState({dateRangeOptions});
    return 'custom';
  }

  bind_rental_unit_list_data = () => {
    console.log('test_property: ', this.props.propertySelected);
    let propertyid = this.props.propertySelected && this.props.propertySelected.id;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalUnits?offset=0&fetch=100&propertyId=' + propertyid,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_list_rental_unit_1',
      null,
      false,
      '',
      {
        // 'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  handle_get_list_rental_unit_1(response){
    if(response.status && response.statuscode === 200){
      if (response.result === null || (response.result && response.result.length === 0)) {
        this.setState({fetchLoader: false, listLoader: false});
      }else{
        let rentalUnits= response.result.map((rentalUnit)=> {
          rentalUnit.tenantsData=[];
          return rentalUnit;
        })
        this.setState({rentalUnits},()=>{
          response.result.map((rentalUnit, index)=> {
            Autoload.HttpRequestAxios.HttpRequest(
              Autoload.Setting.property_api_base_url + 'tenants?offset=0&fetch=100&rentalUnitId=' + rentalUnit.id,
              'GET',
              null,
              null,
              false,
              true,
              false,
              this,
              'handle_get_list_rental_tenants',
              {rentalUnitId: rentalUnit.id, rentalUnitsLength: response.result.length, index},
              false,
              '',
              {
                //'Content-Type': 'application/json',
                Authorization: Autoload.Utils.getAuthToken(),
              }
            );
          });
        });
      }
    }

    if(response.status === false){
      this.setState({fetchLoader: false, listLoader: false});
    }
  }

  handle_get_list_rental_tenants(response){
    let {rentalUnits} = this.state;
    if(response.status && response.statuscode === 200){
      rentalUnits.map((rentalUnit)=> {
        if(rentalUnit.id === response.other.rentalUnitId){
          rentalUnit.tenantsData = response.result;
        }
        return rentalUnit
      });
      this.setState({rentalUnits},()=> {
        if(response.other.rentalUnitsLength === (response.other.index+1)){
          setTimeout(() => {
            let allTenantsList = this.state.tenantOptions;
            let selectedTenantForModal = this.state.selectedTenantForModal;
            let selectedTenant = this.state.selectedTenant;
            rentalUnits.map((rentalUnit)=>
            rentalUnit.tenantsData.map((tenant, index)=> {
              if(tenant.vacant === false){
                allTenantsList.push({
                  value: tenant.id,
                  label: `${tenant.fullName} (${rentalUnit.name})`, //(${tenant.in} - ${tenant.out ? tenant.out : 'nicht verfügbar'})
                  name: tenant.fullName,
                  tenantId: tenant.id,
                  rentalUnit: rentalUnit.name,
                  rentalUnitId: rentalUnit.id
                });

                if(this.state.selectedTenantFromUrlParamsSet === false){
                  selectedTenantForModal.push(tenant.id);
                  selectedTenant.push(tenant.id);
                }
              }
            }));

            this.setState({
              tenantOptions: allTenantsList,
              selectedTenantForModal,
              selectedTenant
            },()=> setTimeout(() => {
              this.evaluateRentalPayments()
            }, 600));
          }, 600);
        }
      });
    }

    if(response.status === false){
      if(response.other.rentalUnitsLength === (response.other.index+1)){
        this.setState({fetchLoader: false, listLoader: false});
      }
    }
  }

  trackScrolling = () => {    
    const wrappedElement = document.getElementById('app-content');
    if (this.isBottom(wrappedElement) && !this.state.listLoader) {
      this.setState({
        offset: this.state.stopOffsetChange ? this.state.offset : this.state.offset + 10,
        listLoader: true}, ()=> this.getRentalPayments()//this.getDocumentsByAccountId()//this.getDocumentsByAccountId()
      );
    }
  };

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  isTop(el) {
    return el.getBoundingClientRect().top <= window.innerHeight;
  }

  getRentalPayments=(replace=false)=>{
    const {selectedDateRange, dateRangeOptions, offset, fetch} = this.state
    console.log('selectedDateRange: ', dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.end);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalPayments/property/' + this.props.propertySelected.id + 
      '?startDate='+ dayjs(dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.start).format('YYYY-MM-DDT00:00:00') + 
      '&endDate='+ dayjs(dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.end).format('YYYY-MM-DDT00:00:00') //+
      //'&offset='+offset+'&fetch='+fetch
      ,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handle_get_rental_payments',
      {replace},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handle_get_rental_payments(response){
    const {rentalUnits, selectedRentModalData} = this.state;
    const replace = response.other?.replace;
    let rentalPayments = replace ? [] : this.state.rentalPayments;
    console.log('handle_get_rental_payments: ', rentalUnits);
    if(response.status && response.statuscode === 200){
      response.result.map((rentalPayment)=> {
        //if(rentalPayments.length === 0 || (rentalPayments.find((value)=> value.id === rentalPayment.id) === undefined)){
          let tenant = null;
          rentalUnits.map((rentalUnit)=>{
            let dataFound = rentalUnit.tenantsData.find((tenant)=> tenant.id === rentalPayment.tenantId);
            tenant = dataFound ? {...dataFound, rentalUnitName: rentalUnit.name} : tenant ? tenant : null;
          });
          rentalPayments.push({
            ...rentalPayment,
            tenant
          });
        //}
      });
      // Keep an open Zahlungseingang modal on the refreshed record, so it shows the
      // recalculated received amounts instead of the ones it was opened with.
      const refreshedSelection = replace && selectedRentModalData ? rentalPayments.find((rentalPayment)=> rentalPayment.id === selectedRentModalData.id) : undefined;
      this.setState({rentalPayments, stopOffsetChange: false, refreshAfterGetRentalPayments: true, ...(refreshedSelection ? {selectedRentModalData: refreshedSelection} : {})});
    }else{
      this.setState({stopOffsetChange: true});
    }
    this.setState({fetchLoader: false, listLoader: false});
  }

  updateRentalPayment=(id, receivedRent, receivedNetRent, receivedAdvancePayment)=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalPayments/'+id,
      'PUT',
      {receivedNetRent, receivedAdvancePayment},
      null,
      false,
      true,
      false,
      this,
      'handle_put_rental_payment',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  evaluateRentalPayments=(replace=false)=>{
    const {selectedTenantId} = this.props;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'rentalPayments/evaluateRentalPayments',
      'POST',
      {propertyId: this.props.propertySelected.id, tenantId: selectedTenantId},
      null,
      false,
      true,
      false,
      this,
      'handleEvaluateRentalPayments',
      {replace},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleEvaluateRentalPayments(response){
    this.getRentalPayments(response.other?.replace);
  }

  handle_put_rental_payment(response){
    let {rentalPayments} = this.state;
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Die Änderungen wurden übernommen.',
        icon: <img src={GreenTick} />,
        id: 'saveRentPaymentsInformation'
      });

      rentalPayments = rentalPayments.map((rentalPayment)=> {
        if(rentalPayment.id === response.result?.id){
          rentalPayment= {...rentalPayment, ...response.result};
        }
        return rentalPayment;
      })
      this.setState({rentalPayments});
    }
  }

  updateProperties(updated_property_response) {
    let {propertySelected} = this.props;
    propertySelected={
      ...propertySelected,
      propertyName: Autoload.MainHelper.checkProperty(updated_property_response, 'name'),
      name: Autoload.MainHelper.checkProperty(updated_property_response, 'name'),
      propertyAdress: Autoload.MainHelper.checkProperty(updated_property_response, 'propertyAdress'),
      propertyAddress: Autoload.MainHelper.checkProperty(
        Autoload.MainHelper.checkProperty(updated_property_response, 'propertyAdress'),
        'streetno'
      ),
      propertyCity: Autoload.MainHelper.checkProperty(
        Autoload.MainHelper.checkProperty(updated_property_response, 'propertyAdress'),
        'city'
      ),
      propertyZipCode: Autoload.MainHelper.checkProperty(
        Autoload.MainHelper.checkProperty(updated_property_response, 'propertyAdress'),
        'zipCode'
      ),
      propertyNoOfUnits: Autoload.MainHelper.checkProperty(updated_property_response, 'numberOfRentalUnits'),
      propertyAreaOfUnits: Autoload.MainHelper.checkProperty(updated_property_response, 'totalRentingSpace'),
      totalRentingSpace: Autoload.MainHelper.checkProperty(updated_property_response, 'totalRentingSpace'),
      numberOfRentalUnits: Autoload.MainHelper.checkProperty(updated_property_response, 'numberOfRentalUnits'),
      cutOffDate: {
        day: 
          Autoload.MainHelper.checkProperty(
          Autoload.MainHelper.checkProperty(updated_property_response, 'cutOffDate'),
          'day',
          '31'
          ),
        month: 
          parseInt(
            Autoload.MainHelper.checkProperty(
              Autoload.MainHelper.checkProperty(updated_property_response, 'cutOffDate'),
              'month',
              '12'
            )
          )
      },
      pictureLocation: Autoload.MainHelper.checkProperty(updated_property_response, 'pictureLocation'),
      totalOccupantsCount: Autoload.MainHelper.checkProperty(updated_property_response, 'totalOccupantsCount'),
      isConsumptionSectionHidden:	Autoload.MainHelper.checkProperty(updated_property_response, 'isConsumptionSectionHidden'),
      isDocumentSectionHidden:	Autoload.MainHelper.checkProperty(updated_property_response, 'isDocumentSectionHidden'),
      isMessageSectionHidden:	Autoload.MainHelper.checkProperty(updated_property_response, 'isMessageSectionHidden'),
    }

    this.props.changeCurrentProperty(propertySelected);
  }

  handleResize = () => {
    if (window.innerWidth <= MOBILE_SIZE) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
    if (window.innerWidth <= TABLET_SIZE) {
      this.setState({ isTablet: true });
    } else {
      this.setState({ isTablet: false });
    }
  };

  handleChange = (event) => {
    this.setState({selectedDateRange: event.target.value});
  };

  onRequestSort = (event, property) => {
    const {order, orderBy} = this.state;
    const isAsc = orderBy === property && order === 'asc';
    this.setState({order: isAsc ? 'desc' : 'asc'});
    this.setState({orderBy: property});
  };

  getTableHeader = () => {
    const {tableHeaderLabels, order, orderBy, allCheckBox, filteredRentalPayments} = this.state;
    const {isMobile} = this.props;
    const createSortHandler = (property) => (event) => {
      this.onRequestSort(event, property);
    };
    return(
      <TableRow>
      {tableHeaderLabels.filter((label)=> isMobile ? (label === 'Mieter' || label === 'Monat' || label === 'Vertragsmiete' || label === 'Zahlungseingang') : label).map((label)=>
      label === 'Miete erhalten' ? 
      <TableCell>
        <Checkbox
        classNames={{input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner'}}
        checked={allCheckBox}
        label={<span style={{whiteSpace: 'nowrap'}}>{label}</span>}
        styles={{
          label: {
            fontSize: '14px',
            marginBottom: 0
          }
        }}
        onChange={()=> this.setState({openUpdateAllTenantRentalReceivedRentModal: true})}
        disabled={filteredRentalPayments.length === 0}
        />
      </TableCell>
      :
      label === 'Aktion' ?
      <TableCell>
        {label}
      </TableCell>
      :
      <TableCell style={{textAlign: (label === 'Vertragsmiete' || (isMobile && label === 'Zahlungseingang')) ? 'right' : 'left'}}>
        <TableSortLabel
          active={orderBy === label}
          direction={orderBy === label ? order : 'asc'}
          onClick={createSortHandler(label)}
          hideSortIcon={label === 'Vertragsmiete' || (isMobile && label === 'Zahlungseingang')}
        >
          {label}
        </TableSortLabel>
      </TableCell>
      )}
      </TableRow>
    )
  };

  onTenantEdit = (id) => {
    this.getRecord(id);
    this.props.history.push('/user/tenant/information?tenantId=' + id);
  };

  getRecord = (id) => {
    const {tenantOptions} = this.state
    const record = tenantOptions.find((rcd) => rcd.tenantId === id);
    this.props.setCurrentTenant(record, record);
  };

  renderTableLastColumns=(rentalPayment)=>{
    const {rentalPayments, tenantEditView} = this.state;
    const {formData} = this.props;
    console.log('window.location.pathname: ', window.location.pathname);
    return(
      <>        
        <TableCell width={'140px'}>
          <Group wrap="nowrap" align={'center'} style={{maxWidth: '140px'}}>
            <Group wrap="nowrap" gap={0} style={{background: (rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) === (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? '#e8f4ea' : (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) > 0)) ? '#f7e3cd' : '#FFCBCB', width: '140px', height: '28px', borderRadius: '15px', padding: '0px 15px'}} justify='space-between' align={'center'}>
              {/* <span style={{color: '#E8193C'}}>{'0,00 €'}</span> */}
              <NumericFormat
              className={`form-control form-control-transparent-rent-income ${(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) === (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? 'rental-income-payment-column-full-paid' : (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) > 0)) ? 'rental-income-payment-column-partial-paid' : 'rental-income-payment-column-not-paid'}`}
              value={(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment)}
              thousandSeparator="." 
              decimalSeparator=","
              onValueChange={(values, sourceInfo) => {
                let newRentalPayments= rentalPayments.map((rp)=> {
                  if(rp.id === rentalPayment.id){
                    rp.receivedAdvancePayment = values.floatValue <= rp.expectedAdvancePayment ? values.floatValue : rp.expectedAdvancePayment;
                    rp.receivedNetRent = values.floatValue - rp.expectedAdvancePayment > 0 ? values.floatValue - rp.expectedAdvancePayment : 0;
                    return rp;
                  }else{
                    return rp;
                  }
                });

                this.setState({rentalPayments: newRentalPayments});
              }}
              suffix={' €'}
              //onKeyPress={this.handleEnterKeyPress}
              placeholder='0,00 €'
              // onFocus={()=> this.setState({vatPercentInFocus: true})}
              onBlur={()=> this.updateRentalPayment(rentalPayment.id, (rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment), rentalPayment.receivedNetRent, rentalPayment.receivedAdvancePayment)}
              decimalScale={2}
              fixedDecimalScale={true}
              allowNegative={true}
              style={{paddingLeft: 10}}
              />
              <img src={PenIcon} onClick={()=> this.setState({openUpdateTenantRentModal: true, selectedRentModalData: rentalPayment})} style={{maxWidth: '12px', marginLeft: '2px', cursor: 'pointer'}} width={'12px'}/>
            </Group>
          </Group>
        </TableCell>
        <TableCell>
          <Group style={{marginTop: '4px'}}>
            <Checkbox
            classNames={{input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner'}}
            checked={(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) == (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment)}
            label={<span style={{whiteSpace: 'nowrap'}}>Miete erhalten</span>}
            styles={{
              label: {
                fontSize: '14px',
                marginBottom: 0
              }
            }}
            onChange={()=> {
              this.updateRentalPayment(rentalPayment.id, 0, (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) == (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment)) ? 0 : rentalPayment.expectedNetRent), (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) == (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment)) ? 0 : rentalPayment.expectedAdvancePayment));
            }}
            />
          </Group>
        </TableCell>
        <TableCell>
          <ColorButton
          text={<span style={{whiteSpace: 'nowrap'}}>Mahnung senden</span>}
          className='gray-btn'
          onClick={()=> this.props.history.push('/messaging/newMessage', {messageType: 'tenantRentMessage', tenantId: rentalPayment.tenantId, rentalPaymentId: rentalPayment.id, previousUrl: tenantEditView ? `/user/tenant/information?tenantId=${formData?.id}` : null})} 
          />
        </TableCell>
      </>
    )
  }

  checkPaymentStatus=(expectedAdvancePayment, expectedNetRent, receivedAdvancePayment, receivedNetRent)=>{
    // if (((expectedAdvancePayment + expectedNetRent) == (receivedAdvancePayment + receivedNetRent)) && (receivedAdvancePayment + receivedNetRent) !== 0){
    //   return 'paid_and_partial_paid';
    // }else if((receivedAdvancePayment + receivedNetRent) === 0 && (expectedAdvancePayment + expectedNetRent) > 0){
    //   return 'unpaid_and_partial_paid';
    // }else 
    if((expectedAdvancePayment + expectedNetRent) <= (receivedAdvancePayment + receivedNetRent)){
      return 'paid';
    }else if((expectedAdvancePayment + expectedNetRent) > (receivedAdvancePayment + receivedNetRent) && (receivedAdvancePayment + receivedNetRent) !== 0){
      return 'partial_paid';
    }else if((receivedAdvancePayment + receivedNetRent) === 0 && (expectedAdvancePayment + expectedNetRent) > 0){
      return 'unpaid';
    }else{
      return 'all';
    }
  }
  
  getTableBody = () => {
    const { isMobile } = this.props;
    const { order, orderBy, selectedPaymentStatus, tenantEditView, filteredRentalPayments } = this.state;
    console.log('selectedPaymentStatus: ', selectedPaymentStatus);

    return(filteredRentalPayments?.length > 0 ? 
    filteredRentalPayments.sort((a,b)=> orderBy === 'Mieter' ? (order === 'asc' ?  a.tenant?.fullName.toLowerCase().localeCompare(b.tenant?.fullName.toLowerCase()) : b.tenant?.fullName.toLowerCase().localeCompare(a.tenant?.fullName.toLowerCase())) 
    : orderBy === 'Mieteinheit' ? (order === 'asc' ? a.tenant?.rentalUnitName.toLowerCase().localeCompare(b.tenant?.rentalUnitName.toLowerCase()) : b.tenant?.rentalUnitName.toLowerCase().localeCompare(a.tenant?.rentalUnitName.toLowerCase())) 
    : orderBy === 'Monat' ? (order === 'asc' ? dayjs(a.rentalMonth) - dayjs(b.rentalMonth) : dayjs(b.rentalMonth) - dayjs(a.rentalMonth))
    : orderBy === 'Vertragsmiete' ? (order === 'asc' ? (a.expectedNetRent + a.expectedAdvancePayment) - (b.expectedNetRent + b.expectedAdvancePayment) : (b.expectedNetRent + b.expectedAdvancePayment) - (a.expectedNetRent + a.expectedAdvancePayment))
    : orderBy === 'Zahlungseingang' && (order === 'asc' ? (a.receivedNetRent + a.receivedAdvancePayment) - (b.receivedNetRent + b.receivedAdvancePayment) : (b.receivedNetRent + b.receivedAdvancePayment) - (a.receivedNetRent + a.receivedAdvancePayment))
    )
    .map((rentalPayment)=>{
          return (
            <TableRow style={{background: '#FFFFFF'}} key={rentalPayment.id}>
              {tenantEditView === false &&
              <TableCell width={'25%'} style={{height: '71px', cursor: 'pointer'}} onClick={()=> this.setState({openUpdateTenantRentModal: true, selectedRentModalData: rentalPayment})}>
                <Group gap={10} wrap="nowrap">
                  <span>{isMobile ? `${rentalPayment.tenant?.fullName} (${rentalPayment.tenant?.rentalUnitName})` : rentalPayment.tenant?.fullName}</span>
                  <img
                  src={PenIcon}
                  alt="Mieter bearbeiten"
                  width={'12px'}
                  style={{cursor: 'pointer', flexShrink: 0}}
                  onClick={(e)=> { e.stopPropagation(); this.onTenantEdit(rentalPayment.tenant?.id); }}
                  />
                </Group>
              </TableCell>}
              {(!isMobile && tenantEditView === false) &&
              <TableCell width={tenantEditView === false && '10%'} style={{cursor: 'pointer'}} onClick={()=> this.setState({openUpdateTenantRentModal: true, selectedRentModalData: rentalPayment})}>
                {rentalPayment.tenant?.rentalUnitName}
              </TableCell>}
              <TableCell width={tenantEditView === false && '10%'} style={{cursor: 'pointer'}} onClick={()=> this.setState({openUpdateTenantRentModal: true, selectedRentModalData: rentalPayment})}>
                {dayjs(rentalPayment.rentalMonth).locale('de').format('MMM YYYY')}
              </TableCell>
              <TableCell style={{textAlign: 'right', cursor: 'pointer'}} onClick={()=> this.setState({openUpdateTenantRentModal: true, selectedRentModalData: rentalPayment})}>
                <span>{(rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? accounting.formatMoney((rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment), { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' }) : '0,00 €'}</span>
              </TableCell>
              {isMobile &&
              <TableCell 
              style={{textAlign: 'right', cursor: 'pointer'}} 
              onClick={()=> this.setState({openUpdateTenantRentModal: true, selectedRentModalData: rentalPayment})}>
                <span className={(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) == (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment) ? 'rental-income-payment-column-full-paid' : (((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) > 0) && ((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) < (rentalPayment.expectedNetRent + rentalPayment.expectedAdvancePayment))) ? 'rental-income-payment-column-partial-paid' : 'rental-income-payment-column-not-paid'}>{(rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment) ? accounting.formatMoney((rentalPayment.receivedNetRent + rentalPayment.receivedAdvancePayment), { symbol: "€",  format: "%v %s", precision: 2, thousand: '.', decimal: ',' }) : '0,00 €'}</span> 
              </TableCell>}
              {!isMobile && this.renderTableLastColumns(rentalPayment)}
            </TableRow>
          )
    })
    :
    <TableRow>
      <TableCell colSpan={7}>
        <EmptyStateContainer
        heading={'Keine Ergebnisse verfügbar.'}
        subheading={'Für diese Suchkriterien sind keine Einträge verfügbar.'}
        showBtn={false}
        icon={Avatar}
        styleMainContainer={{wudth: '100%'}}
        />
      </TableCell>
    </TableRow>);
  };

  handleDateRangeChange = (newDate, type) => {
    const {selectedTenant} =  this.state;

    let newdateRangeOptions = this.state.dateRangeOptions.map((range, index)=> {
        if(index === 2){
          if(type === 'start'){
            range.date = {
              ...range.date,
              start: newDate
            };
            range = {
              ...range,
              label: selectedTenant !== 'all' && `Benutzerdefiniert` //: `Benutzerdefiniert (${dayjs(newDate).format('MMMM YYYY')})` // (${dayjs(newDate).format('MMMM YYYY')} - ${dayjs(range.date.end).format('MMMM YYYY')}) : 
            }
          }else if(type === 'end'){
            range.date = {
              ...range.date,
              end: new Date(moment(newDate).endOf('M'))
            };
            range = {
              ...range,
              label: selectedTenant !== 'all' ? `Benutzerdefiniert` : range.label //(${dayjs(range.date.start).format('MMMM YYYY')} - ${dayjs(newDate).format('MMMM YYYY')})
            }
          }
        return range;
        }else{
        return range;
        }
    });
    
    this.setState({ dateRangeOptions: newdateRangeOptions });
  };

  updateAllCheckBox=()=> {
    const {rentalPayments, allCheckBox, selectedTenant, filteredRentalPayments} = this.state;
    console.log('updateAllCheckBox: ', rentalPayments, selectedTenant);
    if(rentalPayments.length > 0){
      let newRentalPayments= rentalPayments.map((rp)=> {
        if(selectedTenant.find((tenantId)=> rp.tenantId === tenantId) !== undefined && filteredRentalPayments.find((frp)=> frp?.id === rp?.id) !== undefined){
          rp.receivedNetRent= allCheckBox ? 0 : rp.expectedNetRent;
          rp.receivedAdvancePayment= allCheckBox ? 0 : rp.expectedAdvancePayment;
          return rp;
        }else{
          return rp;
        }
      });
  
      this.setState({rentalPayments: newRentalPayments, refreshAfterGetRentalPayments: true}, async()=> {
        await newRentalPayments.map(async(rp)=> await this.updateRentalPayment(rp.id, rp.receivedRent, rp.receivedNetRent, rp.receivedAdvancePayment));
        this.setState({
          allCheckBox: newRentalPayments.filter((rp)=> (rp.receivedNetRent + rp.receivedAdvancePayment) == (rp.expectedNetRent + rp.expectedAdvancePayment)).length === rentalPayments.length, 
          openUpdateAllTenantRentalReceivedRentModal: false
        });
      });
    }
  }

  downloadExcelTable = () => {
    const { rentalPayments, selectedTenant, order, orderBy, tenantEditView } = this.state;
    const { formData, propertySelected } = this.props;

    const propertyInfo = propertySelected?.propertyAddress 
      ? `${propertySelected.propertyAddress}, ${propertySelected.propertyZipCode} ${propertySelected.propertyCity}`
      : propertySelected?.name;
      
    const titleName = tenantEditView ? formData?.name : propertyInfo;
    const firstRowText = `Mieteingang ${titleName} (${moment().format('DD.MM.YYYY')})`;

    const sortedFilteredList = rentalPayments
      .filter((rp) => selectedTenant.includes(rp.tenantId))
      .sort((a, b) => {
        const isAsc = order === 'asc';
        switch (orderBy) {
          case 'Mieter':
            return isAsc 
              ? a.tenant?.fullName.toLowerCase().localeCompare(b.tenant?.fullName.toLowerCase())
              : b.tenant?.fullName.toLowerCase().localeCompare(a.tenant?.fullName.toLowerCase());
          case 'Mieteinheit':
            return isAsc
              ? a.tenant.rentalUnitName.toLowerCase().localeCompare(b.tenant.rentalUnitName.toLowerCase())
              : b.tenant.rentalUnitName.toLowerCase().localeCompare(a.tenant.rentalUnitName.toLowerCase());
          case 'Monat':
            return isAsc ? dayjs(a.rentalMonth) - dayjs(b.rentalMonth) : dayjs(b.rentalMonth) - dayjs(a.rentalMonth);
          case 'Vertragsmiete':
            const valA = a.expectedNetRent + a.expectedAdvancePayment;
            const valB = b.expectedNetRent + b.expectedAdvancePayment;
            return isAsc ? valA - valB : valB - valA;
          case 'Zahlungseingang':
            const recA = a.receivedNetRent + a.receivedAdvancePayment;
            const recB = b.receivedNetRent + b.receivedAdvancePayment;
            return isAsc ? recA - recB : recB - recA;
          default:
            return 0;
        }
      });

    const aoa = [
      [firstRowText],
      [],
      ['Mieter', 'Mieteinheit', 'Monat', 'Vertragsmiete (EUR)', 'Zahlungseingang (EUR)', 'Erhaltene Kaltmiete (EUR)', 'Erhaltene Vorauszahlung (EUR)']
    ];

    let totals = { expected: 0, receivedNet: 0, receivedAdv: 0, receivedTotal: 0 };

    sortedFilteredList.forEach((rp) => {
      const expected = (rp.expectedNetRent + rp.expectedAdvancePayment) || 0;
      const receivedNet = rp.receivedNetRent || 0;
      const receivedAdv = rp.receivedAdvancePayment || 0;
      const receivedTotal = (receivedNet + receivedAdv);

      aoa.push([
        rp.tenant?.fullName,
        rp.tenant?.rentalUnitName,
        dayjs(rp.rentalMonth).format('MMM YYYY'),
        expected,
        receivedTotal,
        receivedNet,
        receivedAdv,
      ]);

      totals.expected += expected;
      totals.receivedTotal += receivedTotal;
      totals.receivedNet += receivedNet;
      totals.receivedAdv += receivedAdv;
    });

    aoa.push([
      '', '', 'Gesamt',
      totals.expected,
      totals.receivedTotal,
      totals.receivedNet,
      totals.receivedAdv,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet(aoa);

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    for (let r = range.s.r + 3; r <= range.e.r; ++r) {
      for (let c = 3; c <= 6; ++c) {
        const cellRef = XLSX.utils.encode_cell({ r, c });
        if (worksheet[cellRef]) worksheet[cellRef].z = '0.00';
      }
    }

    worksheet['!cols'] = Array(7).fill({ wch: 25 });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Mieteingang");
    XLSX.writeFile(workbook, `${firstRowText}.xlsx`);
  };

  renderExportOptions=()=>{
    const {isMobile} = this.props;
    const {exportRentalIncomeTablePopoverOpen, rentalUnits, selectedTenant, dateRangeOptions, selectedDateRange, orderBy, order, tenantEditView} = this.state;
    return(isMobile ?
      <RecordOptions
      showEditButton={false}
      showDeleteButton={false}
      listOfItems={[
          {
            text: 'Excel exportieren',
            leftImage: <img src={XlsxIcon} width={'15px'} />,
            openFunction: (()=> rentalUnits.length > 0 && this.downloadExcelTable())
          },
          {
            text: 'PDF exportieren',
            leftImage: <img src={PdfIcon} width={'15px'} />,
            openFunction: (()=> window.open(`/rentalPaymentsPdfExport?selectedTenant=${encodeURIComponent(JSON.stringify(selectedTenant))}&selectedDateRange=${encodeURIComponent(JSON.stringify({start: dayjs(dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.start), end: dayjs(dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.end)}))}&orderBy=${encodeURIComponent(JSON.stringify(orderBy))}&order=${encodeURIComponent(JSON.stringify(order))}`, '_blank'))
          }
      ]}
      style={{marginRight: '0px'}}
      buttonStyle={{border: 'none', background: 'transparent'}}
      />
      :
      <Group gap={5}>
        <span style={{color: '#454576', marginTop: '-2px'}}>Exportieren: </span>
        <Popover
  opened={exportRentalIncomeTablePopoverOpen}
  width="auto"
  position="bottom"
  withArrow
  // 1. v7 uses onChange to handle outside clicks for controlled popovers
  onChange={(opened) => {
    if (!opened) this.setState({ exportRentalIncomeTablePopoverOpen: false });
  }}
>
  {/* 2. Target Wrapper */}
  <Popover.Target>
    {/* <Tooltip title="Exportieren"> */}
      <IconButton 
        aria-label="filter list"
        disabled={rentalUnits.length === 0}
        onClick={() => this.setState({ exportRentalIncomeTablePopoverOpen: true })} 
        style={{
          background: 'white',
          border: '1px solid #DADAE5', 
          boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
          padding: '5px',
          cursor: 'pointer',
          marginRight: '10px',
          opacity: rentalUnits.length === 0 ? 0.5 : 1
        }}
      >
        <DownloadIcon size="14px" width="11px" height="11px" fill="#5655FE" />
      </IconButton>
    {/* </Tooltip> */}
  </Popover.Target>

  {/* 3. Dropdown Wrapper (p={5} replaces styles.inner padding) */}
  <Popover.Dropdown p={5}>
    <Stack gap={0}>
      <Group 
        // 4. Apply your CSS class here to handle the hover states properly
        className={classes.dropdownItem}
        onClick={() => rentalUnits.length > 0 && this.downloadExcelTable()}
      >
        <img src={XlsxIcon} width="20px" alt="Excel" />
        <span>Excel exportieren</span>
      </Group>
      
      <Group 
        className={classes.dropdownItem}
        onClick={() => window.open(`/rentalPaymentsPdfExport?selectedTenant=${encodeURIComponent(JSON.stringify(selectedTenant))}&selectedDateRange=${encodeURIComponent(JSON.stringify({start: dayjs(dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.start), end: dayjs(dateRangeOptions.find((dateRange)=> dateRange.value === selectedDateRange)?.date?.end)}))}&orderBy=${encodeURIComponent(JSON.stringify(orderBy))}&order=${encodeURIComponent(JSON.stringify(order))}&tenantEditView=${encodeURIComponent(JSON.stringify(tenantEditView))}`, '_blank')}
      >
        <img src={PdfIcon} width="20px" alt="PDF" />
        <span>PDF exportieren</span>
      </Group>
    </Stack>
  </Popover.Dropdown>
</Popover>
      </Group>
    )
  }

  renderFilters=()=>{
    const {dateRangeOptions, selectedDateRange, openDateRangeModal, selectedDateRangeForModal, selectedTenant, tenantOptions, openTenantSelectionModal, selectedTenantForModal, searchTenant, selectedPaymentStatus, selectedPaymentStatusForModal, openPaymentStatusModal, paymentStatusOptions, tenantEditView} = this.state;
    const {isMobile} = this.props;
    console.log('selectedPaymentStatusForModal: ', selectedPaymentStatusForModal);
    return(
      <Group justify="space-between">
        <Group gap={15} className={'tenant-rental-income-filters-container'} wrap="nowrap" style={{overflowX: isMobile && 'scroll', padding: '2px 0px'}}>
          {tenantEditView === false &&
          <Popover
  opened={openTenantSelectionModal}
  // 1. v7 uses onChange to handle outside clicks for controlled popovers
  onChange={(opened) => {
    if (!opened) this.setState({ openTenantSelectionModal: false });
  }}
  position="bottom-start" // 2. Merged position and placement
  withArrow={false}
>
  {/* 3. Target Wrapper */}
  <Popover.Target>
    <Group 
      // Fixed string interpolation bug
      className={`selected-card-filter ${tenantEditView ? 'selected-card-filter-disabled' : ''}`} 
      gap={7} 
      onClick={() => !tenantEditView && this.setState({ openTenantSelectionModal: true })}
    >
      <span 
        style={{ 
          whiteSpace: 'nowrap', 
          maxWidth: isMobile ? '100px' : undefined, // Fixed boolean style bug
          textOverflow: 'ellipsis', 
          overflowX: 'hidden' 
        }}
      >
        {`Mieter: ${selectedTenantForModal.length > 0 ? (selectedTenantForModal.length === tenantOptions.length ? 'Alle' : selectedTenantForModal.length === 1 ? tenantOptions.find((tenant)=> (tenant.value === selectedTenantForModal[0]))?.label ? tenantOptions.find((tenant)=> (tenant.value === selectedTenantForModal[0]))?.label : 'Nicht ausgewählt' : selectedTenantForModal.length > 1 ? 'Mehrere ausgewählt' : 'Nicht ausgewählt') : 'Nicht ausgewählt'}`}
      </span>
    </Group>
  </Popover.Target>

  {/* 4. Dropdown Wrapper */}
  <Popover.Dropdown p="md">
    <Stack gap={20}>
      {/* 5. Replaces the old v4 Popover 'title' prop */}
      <div style={{ fontSize: '14px', fontWeight: 500 }}>
        Mieter auswählen
      </div>

      <div>
        <TextInput 
          className="meter-readings-searchbar" 
          placeholder="Suche nach Mieter oder Einheit ..." 
          value={searchTenant} 
          leftSection={<Icon name="search" />} // 6. Changed icon to leftSection
          onChange={(event) => this.setState({ searchTenant: event.target.value })} 
        />
      </div>

      <Stack gap={10} className="tenant-list-scrollable" style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        {(searchTenant === null || searchTenant === '' || searchTenant === undefined) && (
          <Checkbox 
            classNames={{ input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner' }}
            value="all" 
            label="Alle" 
            styles={{
              label: { fontSize: '14px', marginBottom: 0 }
            }}
            indeterminate={selectedTenantForModal.length > 0 && selectedTenantForModal.length !== tenantOptions.length} 
            checked={selectedTenantForModal.length === tenantOptions.length}
            onChange={(_) => this.setState({ selectedTenantForModal: selectedTenantForModal.length === tenantOptions.length ? [] : tenantOptions.map((tenant) => tenant.value) })}
          />
        )}
        
        {/* 7. CheckboxGroup renamed to Checkbox.Group */}
        <Checkbox.Group
          value={selectedTenantForModal}
          onChange={(value) => this.setState({ selectedTenantForModal: value })}
        >
          {/* 8. Replaces orientation="vertical" */}
          <Stack gap="xs">
            {tenantOptions
              .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
              .filter((tenant) => searchTenant !== null ? (tenant.name.toString().toLowerCase().includes(searchTenant.toString().toLowerCase()) || tenant.rentalUnit.toString().toLowerCase().includes(searchTenant.toString().toLowerCase())) : tenant)
              .map((tenant) => (
                <Checkbox 
                  key={tenant.value} // Added missing React key
                  value={tenant.value} 
                  label={tenant.label} 
                  // Moved classes and styles directly to Checkbox
                  classNames={{
                    input: 'tenants-list-checkbox-rental-income-input', 
                    inner: 'tenants-list-checkbox-rental-income-inner'
                  }}
                  styles={{
                    label: { fontSize: '14px', marginBottom: 0 }
                  }}
                />
            ))}
          </Stack>
        </Checkbox.Group>
      </Stack>
      
      <Group justify="space-between">
        <div>
          <ColorButton
            text="Abbrechen"
            className="gray-btn"
            onClick={() => this.setState({ openTenantSelectionModal: false, selectedTenantForModal: selectedTenant })}
          />
        </div>
        <div>
          <ColorButton
            text="Anwenden"
            className="purple-btn"
            onClick={() => {
              if (selectedTenantForModal.length === 0) {
                showNotification({
                  message: 'Bitte wählen Sie mindestens einen Mieter aus.',
                  icon: <img src={RedCross} alt="Fehler" />
                });
              } else {
                this.setState({
                  openTenantSelectionModal: false, 
                  selectedTenant: selectedTenantForModal
                });
              }
            }}
          />
        </div>
      </Group>
    </Stack>
  </Popover.Dropdown>
</Popover>}


          <Popover
  opened={openDateRangeModal}
  // 1. v7 uses onChange to handle outside clicks for controlled popovers
  onChange={(opened) => {
    if (!opened) this.setState({ openDateRangeModal: false });
  }}
  position="bottom-start" // 2. Merged position and placement
  withArrow={false}
>
  {/* 3. Target Wrapper */}
  <Popover.Target>
    <Group 
      className="selected-card-filter" 
      gap={7} 
      onClick={() => this.setState({ openDateRangeModal: true })}
    >
      <span style={{ whiteSpace: 'nowrap' }}>
        {isMobile 
          ? `Zeitraum: ${dateRangeOptions.find((dateRange) => dateRange.value === selectedDateRange)?.mobileLabel}` 
          : `Zeitraum: ${dateRangeOptions.find((dateRange) => dateRange.value === selectedDateRange)?.label}`}
      </span>
    </Group>
  </Popover.Target>

  {/* 4. Dropdown Wrapper */}
  <Popover.Dropdown p="md">
    <Stack gap={30}>
      {/* 5. Replaces the removed v4 Popover 'title' prop */}
      <div style={{ fontSize: '14px', fontWeight: 500 }}>
        Zeitraum auswählen
      </div>

      <Stack gap={20}>
        {/* 6. RadioGroup renamed to Radio.Group */}
        <Radio.Group
          value={selectedDateRangeForModal}
          onChange={(value) => this.setState({ selectedDateRangeForModal: value })}
          required
        >
          {/* 7. Replaces orientation="vertical" */}
          <Stack gap="xs">
            {dateRangeOptions.map((dateRange) => (
              <Radio 
                key={dateRange.value} // Added missing React key
                value={dateRange.value} 
                label={dateRange.label} 
              />
            ))}
          </Stack>
        </Radio.Group>
        
        <Group 
          justify={isMobile ? 'flex-start' : 'space-between'} 
          wrap="nowrap" 
          className="rental-income-export-date-range"
        >
          <DatePicker
            id="rental-income-export-date-range-picker"
            withPortal={isMobile}
            className="form-control"
            selected={dateRangeOptions[2].date.start}
            onChange={(date) => this.handleDateRangeChange(date, 'start')}
            startDate={dateRangeOptions[2].date.start}
            selectsStart
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            popperPlacement="bottom"
            locale={'de'}
            maxDate={dateRangeOptions[2].date.end}
            disabled={selectedDateRangeForModal !== 'custom'}
          />
          -
          <DatePicker
            id="rental-income-export-date-range-picker"
            className="form-control"
            withPortal={isMobile}
            selected={dateRangeOptions[2].date.end}
            onChange={(date) => this.handleDateRangeChange(date, 'end')}
            startDate={dateRangeOptions[2].date.end}
            selectsStart
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            popperPlacement="bottom"
            locale={'de'}
            minDate={dateRangeOptions[2].date.start}
            disabled={selectedDateRangeForModal !== 'custom'}
          />
        </Group>
      </Stack>
      
      <Group justify="space-between">
        <div>
          <ColorButton
            text="Abbrechen"
            className="gray-btn"
            onClick={() => this.setState({ openDateRangeModal: false, selectedDateRangeForModal: selectedDateRange })}
          />
        </div>
        <div>
          <ColorButton
            text="Anwenden"
            className="purple-btn"
            onClick={() => this.setState({ 
              openDateRangeModal: false, 
              selectedDateRange: selectedDateRangeForModal, 
              offset: 0, 
              stopOffsetChange: false, 
              rentalPayments: [], 
              fetchLoader: true 
            }, () => this.getRentalPayments())}
          />
        </div>
      </Group>
    </Stack>
  </Popover.Dropdown>
</Popover>

          <Popover
  opened={openPaymentStatusModal}
  // 1. v7 uses onChange to handle outside clicks for controlled popovers
  onChange={(opened) => {
    if (!opened) this.setState({ openPaymentStatusModal: false });
  }}
  position="bottom-start" // 2. Merged position and placement
  withArrow={false}
>
  {/* 3. Target Wrapper */}
  <Popover.Target>
    <Group 
      className="selected-card-filter" 
      gap={7} 
      onClick={() => this.setState({ openPaymentStatusModal: true })}
    >
      <span 
        style={{ 
          whiteSpace: 'nowrap', 
          maxWidth: isMobile ? '100px' : undefined, // Fixed boolean style bug
          textOverflow: 'ellipsis', 
          overflowX: 'hidden' 
        }}
      >
        {`Zahlungsstatus: ${selectedPaymentStatusForModal.length === paymentStatusOptions.length ? 'Alle' : paymentStatusOptions.filter((option) => selectedPaymentStatusForModal.find((value) => value === option.value) !== undefined).map((option, index) => index === 0 ? option.label : ` ${option.label}`)}`}
      </span>
    </Group>
  </Popover.Target>

  {/* 4. Dropdown Wrapper */}
  <Popover.Dropdown p="md">
    <Stack gap={30}>
      
      {/* 5. Replaces the removed v4 Popover 'title' prop */}
      <div style={{ fontSize: '14px', fontWeight: 500, marginBottom: '-10px' }}>
        Zahlungsstatus auswählen
      </div>

      <Stack gap={15}>
        <Checkbox 
          classNames={{ input: 'tenants-list-checkbox-rental-income-input', inner: 'tenants-list-checkbox-rental-income-inner' }}
          value="all" 
          label="Alle" 
          styles={{
            label: { fontSize: '14px', marginBottom: 0 }
          }}
          indeterminate={selectedPaymentStatusForModal.length > 0 && selectedPaymentStatusForModal.length !== paymentStatusOptions.length} 
          checked={selectedPaymentStatusForModal.length === paymentStatusOptions.length}
          onChange={(_) => this.setState({ selectedPaymentStatusForModal: selectedPaymentStatusForModal.length === paymentStatusOptions.length ? [] : paymentStatusOptions.map((tenant) => tenant.value) })}
        />
        
        {/* 6. CheckboxGroup renamed to Checkbox.Group */}
        <Checkbox.Group
          value={selectedPaymentStatusForModal}
          onChange={(value) => this.setState({ selectedPaymentStatusForModal: value })}
        >
          {/* 7. Replaces orientation="vertical" */}
          <Stack gap="xs">
            {paymentStatusOptions.map((option) => (
              <Checkbox 
                key={option.value} // Added missing React key
                value={option.value} 
                label={option.label} 
                // Moved classes and styles directly to Checkbox
                classNames={{
                  input: 'tenants-list-checkbox-rental-income-input', 
                  inner: 'tenants-list-checkbox-rental-income-inner'
                }}
                styles={{
                  label: { fontSize: '14px', marginBottom: 0 }
                }}
              />
            ))}
          </Stack>
        </Checkbox.Group>
      </Stack>
      
      <Group justify="space-between">
        <div>
          <ColorButton
            text="Abbrechen"
            className="gray-btn"
            onClick={() => this.setState({ openPaymentStatusModal: false, selectedPaymentStatusForModal: selectedPaymentStatus })}
          />
        </div>
        <div>
          <ColorButton
            text="Anwenden"
            className="purple-btn"
            onClick={() => this.setState({ openPaymentStatusModal: false, selectedPaymentStatus: selectedPaymentStatusForModal })}
          />
        </div>
      </Group>
    </Stack>
  </Popover.Dropdown>
</Popover>
        </Group>
      </Group>
    )
  }

  render() {
    const {isTablet, dateRangeOptions, selectedDateRange, openDateRangeModal, selectedDateRangeForModal, selectedTenant, tenantOptions, openTenantSelectionModal, selectedTenantForModal, searchTenant, openUpdateTenantRentModal, selectedRentModalData, openWebFormModal, rentalPayments, fetchLoader, openUpdateAllTenantRentalReceivedRentModal, tenantEditView} = this.state;
    const {currentSubscription, accountData, propertySelected, loadingTenantsDataValue, isMobile, selectedTenantId} = this.props;

    console.log('selectedTenant: ', selectedTenant);
    console.log('rentalPayments: ', rentalPayments);
    return (
      <Stack>
        {tenantEditView === false &&
        <>
          <div style={{display: 'flex', justifyContent: !isMobile && 'flex-end', width: '100%'}}>
            <Group wrap="nowrap" gap={0} style={{width: '100%'}} justify={isMobile ? 'space-between' : 'right'}>
              {isMobile && this.renderFilters()}
              {this.renderExportOptions()}
            </Group>
          </div>
          <div style={{marginTop: 0}} className='divider'/>
        </>}
        <Box style={{ height: '100%', position: 'relative', marginTop: isStarterTier(currentSubscription) && '40px'}}>
            {false && //(isStarterTier(currentSubscription)) &&
            <Stack align={'center'} style={{ zIndex: 50, position: 'absolute', left: 0, right: 0, marginRight: 'auto', marginLeft: 'auto', marginTop: '200px'}}>
              <Stack gap={0}>
                <span style={{color: '#0E0E1D', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Mieteingänge einfach erfassen</span>
                <span style={{color: '#5555FF', fontSize: '25px', fontWeight: 'bold', textAlign: 'center'}}>Mit hellohousing Premium.</span>
              </Stack>
              <Group>
                <div>
                  <ColorButton
                  text={currentSubscription ? (isStarterTier(currentSubscription) ? (accountData.isPremiumPlanTested === false ? 'Jetzt freischalten' : 'Jetzt freischalten') : isPremiumTier(currentSubscription) ? (accountData.isProfessionalPlanTested === false ? 'Jetzt freischalten' : 'Jetzt freischalten') : 'Jetzt freischalten') : 'Jetzt freischalten'}
                  className='purple-btn'
                  onClick={()=> this.props.history.push('/profile/yourSubscription', {newSubscription: true})}
                  />
                </div>
              </Group>
              <Group style={{width: '460px'}}>
                <span style={{color: '#615C7E', fontSize: '12px', textAlign: 'center'}}>Mieteingänge auf Knopfdruck einfach abgleichen und Mietrückstände direkt aus hellohousing mahnen.</span>
              </Group>
              <Group>
                <span style={{color: '#5555FF', marginLeft: '5px', fontSize: '14px', cursor: 'pointer'}} onClick={()=> window.Intercom('showArticle', '9421578')}>Mieteingangskontrolle kennenlernen</span>
              </Group>
            </Stack>}
          {false &&//(isStarterTier(currentSubscription)) && 
          <Overlay opacity={0.5} blur={4} zIndex={5} color={'#F7F7FA'}/>}

          <Stack id='owner-document' style={{marginTop: selectedTenantId && '20px'}}>
            <Group justify="space-between" align={'center'}>
              {!isMobile && this.renderFilters()}
              {tenantEditView && this.renderExportOptions()}
            </Group>
            

            <Group style={{width: '100%'}}>
              {(fetchLoader) ? 
              <>
                <Skeleton visible={fetchLoader} style={{width: '100%', height: '16px', marginTop: '20px', zIndex: '1'}}/>
                {[...Array(5)].map((e, i) => <Skeleton visible={fetchLoader} style={{height: '75px', zIndex: '1'}}/>)}
              </>
              :
              <TableContainer>
                <Table className='rental-income-list-table'>
                  <TableHead>
                    {this.getTableHeader()}
                  </TableHead>
                  <TableBody>
                    {rentalPayments?.length > 0 ? 
                      this.getTableBody()
                      :
                      <TableRow>
                        <TableCell colSpan={6}>
                          <EmptyStateContainer
                          heading={'Keine Informationen zu Mieteingängen verfügbar.'}
                          subheading={'Nachdem Sie Mietverhältnisse angelegt haben, können Sie hier die Mieteingänge nachverfolgen.'}
                          showBtn={false}
                          icon={Avatar}
                          styleMainContainer={{wudth: '100%'}}
                          />
                        </TableCell>
                      </TableRow>
                      }
                  </TableBody>
                </Table>
              </TableContainer>}
            </Group>
            {openUpdateTenantRentModal && 
            <UpdateTenantRentModal
            open={openUpdateTenantRentModal}
            selectedRentModalData={selectedRentModalData}
            rentalPaymentsForModal={rentalPayments}
            isMobile={isMobile}
            history={this.props.history}
            toggle={()=> this.setState({openUpdateTenantRentModal: false, selectedRentModalData: null})}
            onAssignmentsChanged={()=> this.evaluateRentalPayments(true)}
            saveRentValues={(newRentalPayments, recievedRent, receivedNetRent, receivedAdvancePayment, rentalPaymentId)=> this.setState({openUpdateTenantRentModal: false, selectedRentModalData: null}, ()=> this.updateRentalPayment(rentalPaymentId, recievedRent, receivedNetRent, receivedAdvancePayment))}//this.updateRentalPayment(rentalPaymentId, recievedRent)
            />}

            {openUpdateAllTenantRentalReceivedRentModal &&
            <UpdateAllTenantRentalReceivedRentModal
            open={openUpdateAllTenantRentalReceivedRentModal}
            toggle={()=> this.setState({openUpdateAllTenantRentalReceivedRentModal: false})}
            update={()=> this.updateAllCheckBox()}
            />}
          </Stack>
      </Box>
      </Stack>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    propertySelected: state.generalReducer.property,
    currentSubscription: state.generalReducer.currentSubscription,
    accountData: state.generalReducer.accountData,
    rentalUnits: state.tenantDataReducer.rentalUnits,
    loadingTenantsDataValue: state.tenantDataReducer.loadingTenantsData,
    formData: state.tenantDataReducer.addEditFormData
  };
};

const actions = {
  changeCurrentProperty,
  setCurrentTenant
}

export default connect(mapStateToProps, actions)(TenantRentalIncomeTracking);
